import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const filterObjectRemoveKeys = <T extends Record<string, any>>(
  obj: T,
  keysToRemove?: (keyof T)[]
): Partial<T> => {
  return Object.keys(obj)
    .filter(
      (key) =>
        !keysToRemove?.includes(key as keyof T) &&
        (obj[key] || obj[key] === false || obj[key] === 0)
    )
    .reduce((result, key) => {
      result[key as keyof T] = obj[key];
      return result;
    }, {} as Partial<T>);
};
export const filterObjectRemoveKeysFully = <T extends Record<string, any>>(
  obj: T,
  keysToRemove?: (keyof T)[]
): Partial<T> => {
  return Object.keys(obj)
    .filter((key) => !keysToRemove?.includes(key as keyof T) && !!obj[key])
    .reduce((result, key) => {
      result[key as keyof T] = obj[key];
      return result;
    }, {} as Partial<T>);
};

export const filterObjectKeepKeys = <T extends Record<string, any>>(
  obj: T,
  keysToRemove?: (keyof T)[]
): Partial<T> => {
  return Object.keys(obj)
    .filter(
      (key) =>
        keysToRemove?.includes(key as keyof T) &&
        (obj[key] || obj[key] === false || obj[key] === 0)
    )
    .reduce((result, key) => {
      result[key as keyof T] = obj[key];
      return result;
    }, {} as Partial<T>);
};

export const convertTo12H = (timeString: string) => {
  const match = timeString.match(/(\d+):(\d+):(\d+)/) as RegExpMatchArray;
  let hour = parseInt(match[1]);
  const minute = match[2];
  const period = hour >= 12 ? "PM" : "AM";

  if (hour > 12) {
    hour -= 12;
  } else if (hour === 0) {
    hour = 12;
  }

  return `${hour.toString().padStart(2, "0")}:${minute}:00 ${period}`;
};

export function removeFalsyValues<T extends object>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => Boolean(value))
  ) as Partial<T>;
}

export const roundTo1Decimal = (num: number) => Number(num.toFixed(1));
